'use client'

import { useEffect } from 'react'

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  let stack = error.stack
  let message = error.message
  let digest = error.digest
  useEffect(() => {
    const createJiraTicket = async () => {
      const currentUrl = window.location.href
      const response = await fetch('/api/createJiraTicket', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ stack, message, currentUrl, digest }),
      })
      if (!response.ok) {
        console.error('Failed to create JIRA ticket', await response.text())
      } else {
        // eslint-disable-next-line
        console.log('JIRA ticket created successfully')
      }
    }
    createJiraTicket()
  }, [error])

  return (
    <html lang="en">
      <body
        style={
          // text align center
          { textAlign: 'center', paddingTop: '30px' }
        }
      >
        <h2>Whoops, something went wrong!</h2>
        <p>
          Don&apos;t worry, we&apos;ve alerted our digital team and they are working to resolving
          the issue. We appreciate your patience while we sort this out. Please try again later.
        </p>
      </body>
    </html>
  )
}
